module.exports = __webpack_public_path__ + "img/welcome-samii.2ffda953.png";